
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTargetCameraFilled as ObiTargetCameraFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-target-camera-filled.js';
 
 
 

 
 export const ObiTargetCameraFilled = createComponent({
   react: React,
   tagName: 'obi-target-camera-filled',
   elementClass: ObiTargetCameraFilledElement,
   events: {
     
   }
  });
 
 